<div class="login-page">
  <div class="brand-side" aria-hidden="true">
    <div class="sun"></div>
    <div class="slats"></div>
    <div class="brand-caption">
      <span class="caption-word">Do Your</span>
      <span class="caption-word accent">Shades</span>
      <span class="caption-sub">handcrafted window treatments</span>
    </div>
  </div>

  <div class="login-side">
    <div class="login-card">
      <div class="brand">
        <img class="brand-logo" src="assets/logo.png" alt="Do Your Shades logo" />
        <span class="brand-wordmark">
          <span class="word">Do Your</span><span class="word accent">Shades</span>
        </span>
      </div>

      <p class="eyebrow">Supplier Portal</p>
      <h1>Welcome back</h1>
      <p class="subtitle">Sign in to manage quotes, orders and deliveries.</p>

      @if (error(); as message) {
        <div class="error-banner" role="alert">{{ message }}</div>
      }

      <form (ngSubmit)="submit()">
        <label class="field">
          <span class="field-label">Email</span>
          <span class="input-wrap">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2"></rect>
              <path d="m3 7 9 6 9-6"></path>
            </svg>
            <input
              type="email"
              name="email"
              [(ngModel)]="email"
              autocomplete="email"
              placeholder="you@example.com"
              required
              [disabled]="loading()"
            />
          </span>
        </label>

        <label class="field">
          <span class="field-label">Password</span>
          <span class="input-wrap">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
              <rect x="4" y="11" width="16" height="9" rx="2"></rect>
              <path d="M8 11V7a4 4 0 0 1 8 0v4"></path>
            </svg>
            <input
              type="password"
              name="password"
              [(ngModel)]="password"
              autocomplete="current-password"
              placeholder="••••••••"
              required
              [disabled]="loading()"
            />
          </span>
        </label>

        @if (needsNewPassword()) {
          <label class="field">
            <span class="field-label">New password</span>
            <span class="input-wrap">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                <rect x="4" y="11" width="16" height="9" rx="2"></rect>
                <path d="M8 11V7a4 4 0 0 1 8 0v4"></path>
              </svg>
              <input
                type="password"
                name="newPassword"
                [(ngModel)]="newPassword"
                autocomplete="new-password"
                placeholder="New password"
                required
                [disabled]="loading()"
              />
            </span>
          </label>
        }

        <button type="submit" class="submit-btn" [disabled]="loading()">
          @if (loading()) {
            <span class="spinner" aria-hidden="true"></span>
            <span>{{ needsNewPassword() ? "Saving…" : "Signing in…" }}</span>
          } @else {
            <span>{{ needsNewPassword() ? "Set password & sign in" : "Sign in" }}</span>
          }
        </button>
      </form>

      <p class="footnote">
        Need help? <a href="mailto:support@doyourshades.com">support@doyourshades.com</a>
      </p>
    </div>
  </div>
</div>
